import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, CircularProgress } from "@mui/material";
import { useEffect, forwardRef, Fragment, useState } from "react";
import { styled } from "@mui/system";
import { Product } from "../../app/slices/productsSlice";

export const SelectProducts = forwardRef((props, ref) => {
  const _Products = useSelector((state) => state.product.products);
  const loading = useSelector((state) => state.product.loading);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    dispatch(Product.getAll({ take: 500 }));
  }, [dispatch]);

  // Debounced search when input changes
  useEffect(() => {
    const handler = setTimeout(() => {
      const params = { take: 400 };
      if (inputValue && inputValue.trim().length > 0) {
        params.search = inputValue.trim();
      }
      dispatch(Product.getAll(params));
    }, 400);
    return () => clearTimeout(handler);
  }, [inputValue, dispatch]);

  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    borderBottom: "1px solid #e0e0e0",
    color: "white",
    backgroundColor: theme.palette.primary.main,
  }));
  const GroupItems = styled("ul")({
    padding: 0,
  });

  return (
    <Autocomplete
      ref={ref}
      options={_Products.data || []}
      {...props}
      onInputChange={(event, value, reason) => {
        if (reason === "input" || reason === "clear") {
          setInputValue(value || "");
        }
      }}
      getOptionLabel={(option) =>
        `${option.name} - ${option.total_price?.toLocaleString()} IQD`
      }
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          required={props.required}
          error={props.error}
          helperText={props.helperText}
          {...params}
          label="المنتجات"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
      renderGroup={(params, key) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
});
